import moment from 'moment';
import nric from 'nric';

export default {
  methods: {
    formatPatient(value) {
      return value ? `${value.name} - ${(value.givenIdPrefix || '') + value.givenId}` : '';
    },
    formatPatientId(value) {
      return value ? `${value.givenIdPrefix || ''}${value.givenId}` : '';
    },
    formatAge(momentDOB) {
      let age = 'unknown age';
      if (!momentDOB.isValid()) return age;
      const ageYears = moment().diff(momentDOB, 'years');
      const ageMonth = moment().diff(momentDOB, 'months');
      const ageDays = moment().diff(momentDOB, 'days');
      if (ageYears >= 1) {
        age = `${ageYears} ${this.$t('general.yrsOld')}`;
      } else if (ageMonth >= 1) {
        age = `${ageMonth} ${this.$t('general.mthsOld')}`;
      } else if (ageDays >= 0) {
        age = `${ageDays} ${this.$t('general.daysOld')}`;
      } else {
        age = 'unknown age';
      }
      return age;
    },
    checkSGNricFormat(nricStr) {
      if (nricStr) {
        const result = nric.validate(nricStr);
        return result;
      }
      return false;
    },
    checkMobile(regionCode, mobileNumber) {
      let regExp;
      switch (regionCode) {
        case '+65':
          regExp = /^\+65(8|9)\d{7}$/g;
          break;
        case '+86':
          regExp = /^\+861[0-9]{10}$/g;
          break;
        case '+886':
          regExp = /^\+886((?=(09))[0-9]{10})$/g;
          break;
        default:
          regExp = /^[\+][1-9]\d{9,14}$/g;
          break;
      }
      return regExp.test(mobileNumber);
    },
    checkEmail(email) {
      const validEmailReg = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return String(email)
        .toLowerCase()
        .match(validEmailReg);
    },
  },
};
